import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Urban-Alchemy.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Shelter2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("#"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Digital Empowerment<span className="purple"> for </span> Shelter Residents
            </h1>
            <p className="home-about-body">
            At Choicest Fruit®, we are deeply committed to empowering <b className="purple">underserved communities</b>,
            and one of the ways we do this is through our <b className="purple">Equipping Sheltered Individuals with Computer
            Literacy</b> program. In partnership with Urban Alchemy in Austin, this initiative provides essential computer skills training to
            homeless shelter residents, enabling them to navigate the modern job market and access valuable educational
            resources. By offering training in <b className="purple">basic computer literacy</b>, <b className="purple">
            internet navigation</b>, and <b className="purple">software applications</b>, we equip individuals with the
            digital tools necessary to pursue career opportunities, build resumes, and connect with potential employers.
            <br />
            <br />Our program goes beyond just technical skills. We also provide <b className="purple">career awareness workshops</b> designed
            to help participants explore various career paths, identify their strengths, and understand the steps needed
            to secure sustainable employment. The workshops help participants recognize their own potential, fostering a
            sense of confidence and self-worth. As part of this effort, we assist residents in setting up email addresses,
            creating professional resumes, and joining job portals where they can search for job opportunities. By offering
            these services, we aim to break down barriers to employment, giving individuals the chance to build a brighter,
            more self-sufficient future. Ultimately, this program is about more than just teaching technical skills; it is
            about building <b className="purple">hope</b>, <b className="purple">self-sufficiency</b>, and a <b className="purple">
            sense of empowerment</b>, helping participants take meaningful steps toward improving their lives and achieving long-term success.
          
            <br />
            <br />
            
          </p>
          <Button onClick={handleClick}>Volunteer</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Shelter2;
